import { useQuery } from '@tanstack/react-query';
import { getDetailPipelineQuery } from '../apis';
import queryKeys from '../constants/queryKeys';

// GET /api/pipelines/{id} -> PipelineDto | 404. Used by the Edit dialog to seed initial
// values and by any pipeline detail surface.
const useGetDetailPipeline = id => {
	return useQuery({
		queryKey: queryKeys.getDetail(id),
		queryFn: () => getDetailPipelineQuery(id),
		enabled: !!id,
		// AC-13 — a deep-link to a deleted/non-existent pipeline should resolve to the
		// "no longer available" state promptly; never retry a 404 (mirrors useGetPipelineRun).
		retry: (failureCount, error) => error?.response?.status !== 404 && failureCount < 1
	});
};

export default useGetDetailPipeline;
